export default "__VITE_ASSET__BlyiIe_3__"